import { createStyles, makeStyles } from '@mui/styles';

const SLIDER_BAR_HEIGHT = '20px';

export const useVideoTrimSliderStyles = makeStyles(({ palette, spacing }) => {
  return createStyles({
    videoTrimWrapper: {
      width: '100%',
      padding: `0 ${spacing(5)}`,
      backgroundColor: palette.grey['A100'],
      display: 'flex',
      alignItems: 'center',
      minHeight: 70,
      position: 'relative',
      overflow: 'hidden',
      transform: 'translateY(-6px)',
    },
    sliderWrapper: {
      flexGrow: 1,
      padding: `0 ${spacing(2)}`,
      position: 'relative',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    customSliderRoot: {
      height: `calc(${SLIDER_BAR_HEIGHT} + ${spacing(4)})`,
      padding: 0,
      position: 'relative',
    },
    customSliderRail: {
      backgroundColor: palette.grey['A300'],
      opacity: '1',
      height: SLIDER_BAR_HEIGHT,
      borderRadius: `calc(${SLIDER_BAR_HEIGHT} / 2)`,
    },
    customSliderTrack: {
      backgroundColor: palette.grey['A600'],
      height: SLIDER_BAR_HEIGHT,
      borderRadius: 0,
      border: 'none',
    },
    customSliderThumb: {
      height: `calc((${SLIDER_BAR_HEIGHT}) + ${spacing(2.5)})`,
      width: spacing(),
      backgroundColor: palette.secondary.light,
      borderRadius: spacing(0.5),
      border: 'none',
      marginTop: `calc(-(${SLIDER_BAR_HEIGHT} + ${spacing(
        2.5
      )}) / 2) + (${SLIDER_BAR_HEIGHT} / 2))`,
      boxShadow: 'none',
    },
    videoDurationLabel: {
      color: palette.common.white,
      position: 'absolute',
      transform: 'translateX(-50%)',
      top: spacing(8.5),
      minWidth: spacing(10),
      textAlign: 'center',
    },
  });
});
